import { render, staticRenderFns } from "./ProjectTabPayments.vue?vue&type=template&id=78211282&scoped=true"
import script from "./ProjectTabPayments.vue?vue&type=script&lang=ts"
export * from "./ProjectTabPayments.vue?vue&type=script&lang=ts"
import style0 from "./ProjectTabPayments.vue?vue&type=style&index=0&id=78211282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78211282",
  null
  
)

export default component.exports